import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global response interceptor: surface 402 (subscription required) + 429
// (rate-limit) with friendly toasts so each component doesn't have to
// re-implement the boilerplate. Components can still catch and override.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;

    if (status === 402) {
      const subscribeUrl = detail?.subscribe_url || "/subscribe";
      toast.error("Active subscription required to access this feature.", {
        action: {
          label: "Subscribe",
          onClick: () => {
            window.location.href = subscribeUrl;
          },
        },
      });
    } else if (status === 429) {
      toast.error(
        typeof detail === "string"
          ? detail
          : "Too many requests. Please slow down for a moment.",
      );
    }
    return Promise.reject(error);
  },
);

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (typeof detail === "object" && typeof detail.message === "string")
    return detail.message;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
